import CyberActionButton from "../../components/ui/CyberActionButton";
import MorseBeacon from "../../components/intro/MorseBeacon";
import { variantColorClass, variantAvClass } from "../../components/ui/GameHudStyles";
import { getRoomInfo } from "../../games/rooms";
import { getAvatarUrl } from "../../avatars";
import { getRoleLabel } from "../game/gameRoles";

export default function GameHudRight({
  openIntro, setHintSignal,
  state, players, me, morse,
  openRoomPreview, setRoomPreviewInfoOpen,
}) {
  return (
    <aside className="hidden [@media(min-width:1420px)]:flex w-72 h-[100dvh] max-h-[100dvh] flex-col py-3 px-3 gap-3 overflow-hidden">
      <div className="hud-panel hud-panel-indigo" style={{ flex: 1, minHeight: 0 }}>
        <div className="hud-sec" style={{ display: "flex", gap: 6 }}>
          <CyberActionButton variant="brief" label="BRIEF" tag="Accès" arcOffset={42} onClick={openIntro} />
          <CyberActionButton variant="hints" label="INDICES" tag="Module" arcOffset={28} onClick={() => setHintSignal(n => n + 1)} />
        </div>

        <div style={{ padding: "8px 12px 4px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative", zIndex: 2 }}>
          <span style={{ fontSize: 10, letterSpacing: ".14em", color: "rgba(148,163,184,.85)", textTransform: "uppercase", fontWeight: 700, fontFamily: "ui-monospace,monospace" }}>Équipe en mission</span>
          <span style={{ fontSize: 10, color: "rgba(148,163,184,.6)", fontFamily: "ui-monospace,monospace", fontWeight: 600 }}>Étape {state.stage} · {players.length}J</span>
        </div>

        <div style={{ padding: "4px 8px", display: "flex", flexDirection: "column", gap: 4, overflowY: "auto", flex: 1, minHeight: 0, position: "relative", zIndex: 2 }} className="custom-scrollbar">
          {players.map(p => {
            const isMe = p.id === me.id;
            const avatarUrl = getAvatarUrl(p.avatar);
            const role = getRoleLabel(p);
            const room = getRoomInfo(state.gameId ?? 1, state.stage, p.pageVariant);
            const showMorseOnThumb = !isMe && p.pageVariant === 1 && !!morse?.morseActive && !!morse?.morseStartedAt && state.stage === 1;
            const initials = (p.pseudo || "?").slice(0, 2).toUpperCase();
            return (
              <div key={p.id}
                className={`hud-pcard ${isMe ? "hud-pc-me" : variantColorClass(p.pageVariant)}`}
                onClick={() => openRoomPreview(p)} title="Voir la salle">
                <div className={`hud-av ${isMe ? "hud-av-1" : variantAvClass(p.pageVariant)}`}>
                  {avatarUrl
                    ? <img src={avatarUrl} alt={p.pseudo} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} />
                    : initials}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "rgba(241,245,249,.95)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontFamily: "ui-sans-serif,system-ui", display: "flex", alignItems: "center", gap: 5, lineHeight: 1.3 }}>
                    {p.pseudo}
                    {isMe && <span className="hud-ptag">toi</span>}
                  </div>
                  <div style={{ fontSize: 11, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: 2 }}>{role}</div>
                  <div style={{ fontSize: 10, color: "rgba(148,163,184,.55)", fontFamily: "ui-monospace,monospace", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: 1 }}>{room?.label || "Zone inconnue"}</div>
                </div>
                {room?.icon && (
                  <button type="button" onClick={(e) => { e.stopPropagation(); openRoomPreview(p); }}
                    style={{ width: 36, height: 36, borderRadius: 7, overflow: "hidden", background: "rgba(255,255,255,.07)", border: "1px solid rgba(255,255,255,.12)", flexShrink: 0, position: "relative", cursor: "pointer" }}
                    title="Voir la salle en grand">
                    <img src={room.icon} alt={room.label} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    {showMorseOnThumb && (
                      <MorseBeacon active syncStartedAt={morse?.morseStartedAt} syncResetCounter={morse?.morseResetCounter || 0} serverNow={morse?.serverNow} hideResetLabel className="inset-0 !w-full !h-full" />
                    )}
                    <div style={{ position: "absolute", top: -3, right: -3, background: "rgba(99,102,241,.9)", border: "1px solid rgba(255,255,255,.2)", borderRadius: "50%", fontSize: 7, padding: "1px 3px" }}>🔍</div>
                  </button>
                )}
              </div>
            );
          })}
          {players.length === 0 && <p style={{ fontSize: 9, color: "rgba(71,85,105,.6)", fontFamily: "ui-monospace,monospace", padding: "8px 4px" }}>Aucun joueur connecté.</p>}
        </div>

        <div className="hud-divh" />

        <div style={{ padding: "6px 8px 8px", flex: 1, minHeight: 0, display: "flex" }}>
          <div className="hud-prev-zone" onClick={() => setRoomPreviewInfoOpen(true)}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", border: "1px solid rgba(99,102,241,.35)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>👁</div>
            <div style={{ fontSize: 9, letterSpacing: ".12em", textTransform: "uppercase", color: "rgba(100,116,139,.7)", fontWeight: 700, fontFamily: "ui-monospace,monospace" }}>Aperçu de salle</div>
            <div style={{ fontSize: 10, color: "rgba(100,116,139,.55)", fontFamily: "ui-sans-serif,system-ui", textAlign: "center", padding: "0 10px" }}>
              {state.stage === 3 ? "Même salle pour tous" : "Clique 🔍 sur un joueur"}
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}